import { ChainId } from '@ui/types/chain';
import { BareTradePair } from '@ui/types/tradePair';
import { Nullable } from 'vitest';

import { genesisAirdropControllerApi } from '../../clients/clients';
import { GetTeamMembers14YxddURequest } from '../../generated';
import { toServerBlockChain } from '../../utils';

export type TeamMemberParam = {
  userAddress: Nullable<GetTeamMembers14YxddURequest['userAddress']>;
  page: number;
  size: number;
};

const getKey = (params: TeamMemberParam) => {
  return ['genesisAirdropControllerApi', 'teamMembers', params];
};
const getFn =
  ({ ...params }: TeamMemberParam) =>
  async () => {
    if (!params.userAddress) {
      throw new Error('Query should not be called');
    }

    return genesisAirdropControllerApi.getTeamMembers14YxddU({
      userAddress: params.userAddress,
      page: params.page,
      size: params.size,
    });
  };

export const teamMemberQuery = {
  getKey,
  getFn,
};
